var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerSpeedTurbo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 6.003a.75.75 0 011.277-.533l6.059 5.997a.75.75 0 010 1.066L5.402 18.53a.75.75 0 01-1.277-.533V6.003zM13.125 6.003a.75.75 0 011.277-.533l6.059 5.997a.75.75 0 010 1.066l-6.059 5.996a.75.75 0 01-1.277-.533V6.003z",
    fill: "currentColor"
  })));
}
SvgPokerSpeedTurbo.displayName = 'PokerSpeedTurbo';
export default SvgPokerSpeedTurbo;